// Message 
export const ADD_MESSAGE = '/email/'; 

// Notification
export const NOTIFICATION = '/notification';
export const GET_NOTIFICATION = '/notification/';
export const DELETE_NOTIFICATION = '/notification';
export const ADD_NOTIFICATION = '/notification/';
export const ADD_BULK_NOTIFICATION = '/notification/bulk';
export const UPDATE_NOTIFICATION = '/notification';
export const READ_NOTIFICATION = '/notification/read';
export const READ_BULK_NOTIFICATION = '/notification/bulk/read';
// Notification WebSocket
export const NOTIFICATION_WEBSOCKET = '/notification/ws';


// Notification Type
export const NOTIFICATION_TYPE = '/notification_type';
export const GET_NOTIFICATION_TYPE = '/notification_type/';
export const DELETE_NOTIFICATION_TYPE = '/notification_type';
export const ADD_NOTIFICATION_TYPE = '/notification_type/'; 
export const UPDATE_NOTIFICATION_TYPE = '/notification_type';

// Notification Priority
export const NOTIFICATION_PRIORITY = '/notification_priority';
export const GET_NOTIFICATION_PRIORITY = '/notification_priority/';
export const DELETE_NOTIFICATION_PRIORITY = '/notification_priority';
export const ADD_NOTIFICATION_PRIORITY = '/notification_priority/'; 
export const UPDATE_NOTIFICATION_PRIORITY = '/notification_priority';